import {Component, OnInit} from '@angular/core';
import {LockScreenService} from '../common/lock-screen.service';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {AcceptTermsConditionsService} from '../common/accept-terms-conditions.service';
import {connectApi} from '../common/connect-api';
import {AcceptTermsConditions} from './accept-terms-conditions';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {AcceptTermsConditionsDto} from './accept-terms-conditions-dto';
import {ErrorService} from '../common/error.service';
import {User} from "../common/user";

@Component({
    selector    : 'dp-accept-terms-conditions',
    templateUrl : './accept-terms-conditions.component.html'
})

export class AcceptTermsConditionsComponent implements OnInit {
    routerState : any;
    nextState : any;
    isUserAvailable : boolean = false;
    errorMessages : string[] = [];
    termsAndConditions: string;
    accepted: boolean = false;
    termsAcceptedDate: Date;

    constructor(
        public lockScreenService: LockScreenService,
        private httpClient: HttpClient,
        private router: Router,
        private acceptTermsConditionsService: AcceptTermsConditionsService,
        private errorService: ErrorService) {
        this.routerState = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : undefined;
    }

    ngOnInit(): void {
        this.acceptTermsConditionsService.getTermsAndConditions().subscribe(
            (res) => {
                this.termsAndConditions = res.termsAndConditions;
                this.termsAcceptedDate = res.createdDate;
            }
        );
        if (this.routerState){
            this.nextState = this.routerState.nextState;
        }
        if(sessionStorage.getItem(SESSION_STORAGE_KEYS.user)){
            this.isUserAvailable = true;
        }
    }

    submit() {
        if (this.accepted) {
            this.lockScreenService.lockScreen = true;
            const sessionUser = sessionStorage.getItem(SESSION_STORAGE_KEYS.user);
            if (sessionUser) {
                this.isUserAvailable = true;
                const acceptTermsConditionsDTO = new AcceptTermsConditionsDto();
                acceptTermsConditionsDTO.termsAcceptedDate = this.termsAcceptedDate;
                acceptTermsConditionsDTO.userId = Number(JSON.parse(sessionUser).id);

                this.acceptTermsConditionsService.setupTermsAndConditions(acceptTermsConditionsDTO).subscribe(
                    (res) => {
                        if (this.nextState) {
                            this.router.navigate(['./home/matter-summary-home'],{state: {nextState: this.nextState}});
                        } else {
                            this.router.navigate(['./home'] );
                        }
                    },
                    (err: HttpErrorResponse) => {
                        this.errorMessages.push(this.errorService.getErrorMessage(err));
                    }
                );
            }
        }
    }

}
